module.exports = __webpack_public_path__ + "img/edit-outline-blugrey.a0c105e7.svg";